import React from 'react';
import { Link, Switch, Route, useRouteMatch, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { NavTab, NavTabItem, PropInfo, PropsTable } from '@cimpress/react-components'; // eslint-disable-line import/no-unresolved

const ComponentDocTabs = ({ activeTab, basePath }: { activeTab: string; basePath: string }) => {
  const tabs = [
    {
      displayName: 'Example',
      route: '',
    },
    {
      displayName: 'Props',
      route: '/props',
    },
  ];

  return (
    <NavTab>
      {tabs.map(tab => (
        <NavTabItem key={tab.displayName} active={activeTab === tab.route}>
          <Link to={`${basePath}${tab.route}`}>{tab.displayName}</Link>
        </NavTabItem>
      ))}
    </NavTab>
  );
};

ComponentDocTabs.propTypes = {
  activeTab: PropTypes.string,
  basePath: PropTypes.string,
};

type ComponentDocProps<T> = {
  name: string;
  includeTabs?: boolean;
  propInfos: PropInfo<T>[];
  children?: React.ReactNode;
  remarks?: React.ReactElement;
};

export default function ComponentDoc<T>({
  name,
  includeTabs = true,
  propInfos = [],
  children,
  remarks,
}: ComponentDocProps<T>) {
  // eslint-disable-line
  const propsTable = propInfos?.length ? <PropsTable propInfos={propInfos} /> : null;
  const { path } = useRouteMatch();
  const location = useLocation();

  return (
    <div>
      <div className="row" style={{ paddingBottom: '10px' }}>
        <div className="col-md-12">
          <h2>{name}</h2>
          {includeTabs ? <ComponentDocTabs activeTab={location.pathname.replace(path, '')} basePath={path} /> : null}
          <Switch>
            <Route path={`${path}/example`} render={() => <div>{children}</div>} />
            <Route
              path={`${path}/props`}
              render={() => (
                <>
                  {remarks || null}
                  {propsTable}
                </>
              )}
            />
            <Route path={path} render={() => <div>{children}</div>} />
          </Switch>
        </div>
      </div>
    </div>
  );
}
